import axios from "axios"
import { store } from "../../stateManagement/store"
import { setItemWebStorage } from "../webStorageSaver"
import { setCustomAuthToken, setNumberOfAuthTry } from "../../stateManagement/reducers/custom/CustomAuthSlice"

export async function authorizeToCustomRest(restAuthRequestOptions: any) {
    const { url, headers, body } = restAuthRequestOptions
    const numberOfAuthTry = store.getState().customAuth.numberOfAuthTry
    let newHeaders = { ...headers }
    if (headers?.Authorization.includes('Basic')) {
        const spaceSplit = newHeaders?.Authorization.split(' ')
        if (spaceSplit.length === 3) {
            let credentials = `${spaceSplit[1]}:${spaceSplit[2]}`
            let credentialsBase64 = btoa(credentials)
            newHeaders.Authorization = `Basic ${credentialsBase64}`
        }
    }
    store.dispatch(setNumberOfAuthTry(numberOfAuthTry + 1))
    try {
        const response: any = await axios.post(url, body, { headers: newHeaders });
        const { access_token } = response?.data
        store.dispatch(setCustomAuthToken(access_token))
        setItemWebStorage('customAuthToken', access_token)
    } catch (error) {
        console.error(error)
    }
}